"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Section = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var ui_text_1 = require("@hopin-team/ui-text");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var isInverseStyles = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY[\"400\"]", theme);
}); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore styled-component union too complicated?

exports.Section = (0, styled_components_1.default)(ui_text_1.Text).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['isInverse'].includes(prop);
  }
})(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  cursor: default;\n  padding: 0.5rem 0.75rem;\n  user-select: none;\n  ", "\n"], ["\n  cursor: default;\n  padding: 0.5rem 0.75rem;\n  user-select: none;\n  ", "\n"])), function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'isInverse', isInverseStyles);
});
var templateObject_1, templateObject_2;